/* HANTINO — mobilmenyns öppna/stäng-knapp.
   Panelen med länkar och knappar ligger alltid i DOM:en. På desktop renderas
   den inline (display: contents), på mobil fälls den ut under logotypraden. */
(function () {
  'use strict';

  var nav = null;
  var toggle = null;

  function close() {
    if (!nav) return;
    nav.classList.remove('is-open');
    toggle.setAttribute('aria-expanded', 'false');
  }

  function init() {
    toggle = document.querySelector('[data-hnt-nav-toggle]');
    if (!toggle) return;
    nav = toggle.closest('.hnt-nav');
    if (!nav) return;

    toggle.addEventListener('click', function () {
      var open = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });

    /* Stäng vid Escape och när man klickar en länk i panelen */
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
    });
    nav.addEventListener('click', function (e) {
      if (e.target.closest('.hnt-nav__panel a')) close();
    });

    /* Dropdown i menyn (t.ex. Produkter): klick på rubriken öppnar och
       stänger listan, klick utanför eller Escape stänger. På desktop öppnar
       även hover, det sköter css. */
    var dds = nav.querySelectorAll('[data-hnt-dd]');
    function closeDds(except) {
      dds.forEach(function (dd) {
        if (dd === except) return;
        dd.classList.remove('is-open');
        var b = dd.querySelector('.hnt-nav__dd-btn');
        if (b) b.setAttribute('aria-expanded', 'false');
      });
    }
    dds.forEach(function (dd) {
      var btn = dd.querySelector('.hnt-nav__dd-btn');
      if (!btn) return;
      btn.addEventListener('click', function () {
        var open = dd.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        closeDds(dd);
      });
    });
    if (dds.length) {
      document.addEventListener('click', function (e) {
        if (!e.target.closest('[data-hnt-dd]')) closeDds(null);
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') closeDds(null);
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
